import { render, staticRenderFns } from "./MypageLanguageSettingPage.vue?vue&type=template&id=50d8d14c"
import script from "./MypageLanguageSettingPage.vue?vue&type=script&lang=ts"
export * from "./MypageLanguageSettingPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports